import React from "react";
import { Card, Button, Typography, Col } from "antd";
import { css } from "@emotion/css";
import ArrowCircleRight2Icon from "../../../../Theme/CustomIcons/Icons/Arrow/ArrowCircleRight2Icon";
import { useDispatch } from "react-redux";
import { toggleSupportCard } from "../../../../store/action/admin/onboardingActions";

const { Title, Text } = Typography;

const NeedHelp = () => {
  const dispatch = useDispatch();

  const handleContactClick = () => {
    dispatch(toggleSupportCard(true));
  };

  return (
    <Col span={24}>
      <Card
        title={`Need Help?`}
        className={css`
          margin-bottom: 16px;
          height: 208px;
          width: 480px;
          position: relative;
          overflow: hidden;
        `}
      >
        <div
          className={css`
            position: absolute;
            top: 0;
            right: 0;
            width: 130.12px;
            height: 129.26px;
            transform: translate(25%, -25%);
            z-index: 1;
          `}
        >
          <img
            src="/logo192.png"
            alt="Decorative shapes"
            className={css`
              width: 100%;
              height: 100%;
              object-fit: contain;
            `}
          />
        </div>

        <div
          className={css`
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
          `}
        >
          <div>
            <Text
              className={css`
                color: #9c92a6;
                font-size: 14px;
              `}
            >
              Schedule a call and we'll help you find <br />
              your next hire
            </Text>
          </div>
        </div>

        <Button
          className={css`
            width: 100%;
            background-color: transparent;
            height: 48px !important;
            min-width: 48px;
            min-height: 48px;
            display: flex;
            align-items: center;
            justify-content: center;
            margin-top: 16px;
            font-weight: 700 !important;
          `}
          onClick={handleContactClick}
        >
          Contact us <ArrowCircleRight2Icon size="medium" color="#ffffff" />
        </Button>
      </Card>
    </Col>
  );
};

export default NeedHelp;
